import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getVerbindlichkeitenLists = async (payload) => {
    try {
        const response = await axios.post('/customer/verbindlichkeiten/get', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getByIdVerbindlichkeiten = async (id) => {
    try {
        const response = await axios.get(`/customer/verbindlichkeiten/get/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteVerbindlichkeiten = async (id) => {
    try {
        const response = await axios.put(`/customer/verbindlichkeiten/delete/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const createVerbindlichkeiten = async (payload) => {
    try {
        const response = await axios.post('/customer/verbindlichkeiten/create', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateVerbindlichkeiten = async (payload) => {
    try {
        const response = await axios.put('/customer/verbindlichkeiten/update', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}